export default __webpack_public_path__ + "static/media/Check_list_inspection_mensuelle_IBS.1012abe7.doc";